import { computed } from 'vue';
import { type SkinInteractive } from 'data-types-config';

/**
 * useSkinInteractive - Interactive-specific CSS classes only.
 */
export default function useSkinInteractive(props: Partial<SkinInteractive>) {
  const allClasses = computed(() => {
    const classes = [
      props.context ? 'btn' : '',
      props.context ? `btn-${props.context}` : '',
      props.size ? `btn-${props.size}` : '',
      props.size === 'lg' ? 'text-uppercase' : '',
      props.isBlock ? 'w-100' : '',
      props.isDisabled ? 'disabled' : '',
    ].filter(Boolean);
    return classes.join(' ');
  });

  return {
    allClasses,
  };
}
